<style scoped>
    .hRiNVv {
        display: flex;
        flex-wrap: wrap;
        margin-right: -1rem;
        margin-left: -1rem;
    }

    .kAuxep {
        margin-bottom: 3rem;
        text-align: center;
        width: 100%;
        font-size: 1.75rem;
        line-height: 1.5;
        text-transform: none;
        color: #333333;
        font-family: Poppins, sans-serif;
        font-weight: 600;
    }
    .kHalqn {
        display: flex;
        flex-wrap: wrap;
    }

    @media (min-width: 48em){
        .bbSNKi {
            flex: 0 0 33.3333%;
            max-width: 33.3333%;
        }
    }
    .bbSNKi {
        width: 100%;
        padding-right: 1rem;
        padding-left: 1rem;
        margin-bottom: 1rem;
    }

    .jwEESt {
        box-shadow: rgba(0, 0, 0, 0.16) 0px 4px 16px 0px;
        border: none;
        background-color: rgb(255, 255, 255);
        border-radius: 16px;
        color: rgb(51, 51, 51);
        display: flex;
        flex-direction: column;
        position: relative;
        z-index: 1;
        cursor: pointer;
    }

    .iPJVxL {
        height: 120px;
        margin-bottom: -0.25rem;
    }

    .fOvjJV {
        text-align: center;
        padding: 1.25rem 1.5rem;
        margin-bottom: auto;
    }

    .MaXNS {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        font-family: Poppins, sans-serif;
        font-weight: 600;
        font-size: 1rem;
        line-height: 1.25;
        margin-bottom: 1rem;
    }

    .jncVeH {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        color: rgb(51, 51, 51);
        font-size: 1rem;
        line-height: 1.25rem;
    }

    .cUEVNk {
        text-align: center;
        padding: 0px 1.25rem 1.25rem;
        margin-top: -0.25rem;
    }

    .iPJVxL {
        height: 120px;
        margin-bottom: -0.25rem;
    }
    .iPJVxL > img {
        object-fit: cover;
        height: 100%;
        width: 100%;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
    }

    .ckZliQ {
        color: rgb(34, 44, 155);
        background-color: transparent;
        border: none;
        padding: 0px;
    }

    .cnnpss:hover, .cnnpss.hover {
        text-decoration: none;
    }
    .recentblog-home{
        padding: 40px 0px;
    }
</style>
<template>
    <section class="recentblog-home">
        <div class="container">
            <div class="hRiNVv">
                <h2 class="kAuxep">Post recenti sul blog</h2>
                <div class="kHalqn">
                        <div class="bbSNKi" v-for="recentblog in recentBlogs" :key="recentblog.id">
                            <div class="jwEESt">
                                <div class="iPJVxL">
                                    <img v-if="recentblog.image != null" loading="lazy" width="240" :src="recentblog.image" :alt="recentblog.title" :srcset="recentblog.image">
                                    <img v-else src="/themes/storefront/public/images/image-placeholder.png" :alt="recentblog.title" loading="lazy" width="240">
                                </div>
                                <div class="fOvjJV">
                                    <span class="MaXNS">{{ recentblog.title }}</span>
                                    <span class="jncVeH" v-html="recentblog.description"></span>
                                </div>
                                <div class="cUEVNk">
                                    <a :aria-label="recentblog.title" :href="recentblog.url" class="cnnpss ckZliQ">Leggi di più</a>
                                </div>
                            </div>
                        </div>

                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                recentBlogs: [],
            };
        },
        mounted() {
            this.loading = true;
            $.ajax({
                method: "GET",
                url: '/it/getrecentblogposts?latest=3',
                context: this
            }).then(async recentBlogs => {
                this.recentBlogs = recentBlogs.response;
            });
        }
    };
</script>
